export default __webpack_public_path__ + "static/media/agenteNC.e8d49fb5.svg";